module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answer"
  }, [_c('div', {
    staticClass: "question-content-wrapper"
  }, [_c('div', {
    staticClass: "comment-content-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goDetailComment(_vm.comment)
      }
    }
  }, [(!_vm.comment.is_child) ? _c('p', {
    class: ['comment-left', {
      'active': _vm.comment.is_vote_up
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onApproval(_vm.comment)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.comment.vote_up_num))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.comment.is_vote_up ? '已赞' : '赞同'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "comment-desc"
  }, [(_vm.comment.is_accept) ? _c('span', {
    staticClass: "tag adopted"
  }, [_vm._v("已采纳")]) : _vm._e(), _vm._v(" "), (_vm.comment.is_child) ? [_c('span', [_vm._v("回复")]), _vm._v(" "), _c('span', {
    staticClass: "comment-name",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHomePage(_vm.comment.commented_by)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.comment.commented_by.nick_name) + "\n                    ")]), _vm._v(" "), _c('span', [_vm._v(" 的回答：")])] : _c('span', [_vm._v("回答：")]), _vm._v("\n                “ "), _c('span', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.comment.simple_comment))]), _vm._v(" ”\n                "), (_vm.comment.isViewDetail) ? _c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goDetailComment(_vm.comment)
      }
    }
  }, [_vm._v("\n                    查看详情\n                    "), _c('img', {
    staticClass: "share-icon",
    attrs: {
      "src": require("../../../images/personal_center/share.png"),
      "alt": ""
    }
  })]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "comment-bottom-content"
  }, [(_vm.isSelf) ? _c('p', {
    staticClass: "answer-text delete",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteArticle(_vm.comment)
      }
    }
  }, [_c('i', {
    staticClass: "smart-img"
  }), _vm._v(" "), _c('span', [_vm._v("删除回答")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "topic-people"
  }, [_vm._v(_vm._s(_vm.comment.created_on))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5058dcab!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/my_question/answer.vue
// module id = R9P8
// module chunks = 15